import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/locationgcc/dxb/banner_bg.webp";
import Bannerfrom from "../../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Dubai">
                <h1>App Marketing Company in Dubai</h1>
              </div>
              <p className="main_para">
                TekRevol, the trusted app marketing Agency in Dubai, ensures
                timely success by boosting app installs, refining store
                presence, and improving user acquisition. Our custom-tailored
                app marketing strategies realign your digital course, optimizing
                monthly spending and employing advanced techniques for
                efficient, unrivaled outcomes. TekRevol as your app marketing
                partner, witness a transformative journey toward app success and
                drive unparalleled growth.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
